import message from './message';

export default message;
